export default "__VITE_ASSET__BYDYPpiT__"